// utils/pageTitle.js
export const getPageHeaderTitle = () => {
  const slug = window.location.pathname.split('/').filter(Boolean).pop();
  const map = {
    tradingcycle: "Trading Cycle",
    journal: "Journal",
    dashboard: "Dashboard"
  };
  return map[slug] || slug;
};
